var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#DEE8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.76 11.3594V42.6394H39.24V19.9231L39.0488 19.7106L30.8888 11.5506L30.6763 11.3594H14.76ZM16.12 12.7194H29.72V20.8794H37.88V41.2794H16.12V12.7194ZM31.08 13.6969L36.9025 19.5194H31.08V13.6969ZM20.2 24.9594V26.3194H33.8V24.9594H20.2ZM20.2 29.0394V30.3994H31.08V29.0394H20.2ZM20.2 33.1194V34.4794H33.8V33.1194H20.2Z",
    fill: "#0050D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document_upload.8bd828d50bb85cefd34de3f8473cfcbc.svg";
export { ForwardRef as ReactComponent };